import DatePicker, { DatePickerProps, registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nl } from "date-fns/locale/nl";
import { format, subYears } from "date-fns";
import "./DatePicker.scss";
import tryParseDate from "@/helpers/tryParseDate";
import { useState } from "react";
registerLocale("nl", nl);

export default (props: {
  //Omit<DatePickerProps, 'onChange'> &
  id?: string;
  name?: string;
  className?: string;
  value: string;
  onChange?: (date: Date | null) => void;
  onChangeString?: (date: string | null) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
} & DatePickerProps) => {
  const { onChange, onChangeString, className, value, placeholder, minDate, maxDate, ...otherProps } =
    props;
  const [typedValue, setTypedValue] = useState<string>();
  const handleChange = (date: Date | null) => {
    const res = date ? format(date, "yyyy-MM-dd") : null;
    onChange && onChange(date);
    onChangeString && onChangeString(res);
  };

  const handleRaw = (e: any) => {
    const value = e.target.value;
    setTypedValue(value);
  };

  const handleBlur = () => {
    if (typedValue && typedValue.length > 0) {
      const value = tryParseDate(typedValue);
      handleChange(value);
    }
    setTypedValue(undefined);
  };


  return <DatePicker
    {...otherProps}
    wrapperClassName={className}
    locale="nl"
    selected={value ? new Date(value) : null}
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    scrollableYearDropdown
    minDate={minDate as Date ?? undefined}
    maxDate={maxDate as Date ?? undefined}
    onChangeRaw={handleRaw}
    onBlur={handleBlur}
    onChange={(date: any) => handleChange(date)}
    dateFormat="dd-MM-yyyy"
    placeholderText={placeholder ?? "Kies of vul datum in (dd-mm-yyyy)"}
  />
};
